<template>
  <b-navbar toggleable="lg" type="dark" variant="dark">
    <b-container>
    <b-navbar-brand :to="{ name: 'homepage' }">
      <img class="navbar-brand-logo" alt="chronext-white-logo" src="@/assets/chronext-logo-white.svg" />
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"/>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item v-if="isLoggedIn && hasAnyOfTheseRoles(['supplier_buying', 'supply_agent'])" :to="{ name: 'selling-offers' }">B2B-Sale</b-nav-item>
        <b-nav-item v-if="isLoggedIn && hasAnyOfTheseRoles(['supplier_selling', 'supply_agent'])" :to="{ name: 'buying-demand' }">Demand</b-nav-item>
        <b-nav-item v-if="isLoggedIn && hasAnyOfTheseRoles(['supplier_bulk'])" :to="{ name: 'bulk-upload' }">Stocklist Upload</b-nav-item>
        <b-nav-item-dropdown v-if="isLoggedIn && hasAnyOfTheseRoles(['supply_agent'])" text="Admin">
          <b-dropdown-item :to="{ name: 'admin' }">Dashboard</b-dropdown-item>
          <b-dropdown-item v-if="usersDashboardEnable" :to="{ name: 'users' }">Users</b-dropdown-item>
          <b-dropdown-divider/>
          <b-dropdown-item v-if="demandOverviewEnable" :to="{ name: 'admin-demand-overview' }">Demands</b-dropdown-item>
          <b-dropdown-divider v-if="demandOverviewEnable"/>
          <b-dropdown-item :to="{ name: 'admin-sellingoffers' }">Selling Offers</b-dropdown-item>
          <b-dropdown-divider/>
          <b-dropdown-item :to="{ name: 'admin-demands' }">Purchase Offers</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'admin-accepted-purchaseoffers' }">Accepted Purchase Offers</b-dropdown-item>
          <b-dropdown-divider/>
          <b-dropdown-item v-if="purchaseOrdersOverviewEnable" :to="{ name: 'admin-orders' }">Purchase Orders</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown v-if="isLoggedIn" :text="email" right>
          <b-dropdown-item @click="logout()">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item v-else :to="{ name: 'login' }">Login</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-container>
  </b-navbar>
</template>
<script>
import store from 'src/store';
import router from 'src/router';
import { hasAnyOfTheseRoles } from 'src/auth';
import featuresFlags from '@/mixins/featuresFlags';

export default {
  name: 'Navbar',
  mixins: [featuresFlags],
  methods: {
    logout() {
      store.dispatch('logout').then(() => {
        router.push({ name: 'homepage' });
      });
    },
    hasAnyOfTheseRoles(roles) {
      return hasAnyOfTheseRoles(roles);
    },
  },
  computed: {
    email() {
      return store.state.user.email;
    },
    isLoggedIn() {
      return store.state.loggedIn;
    },
  },
};
</script>

<style scoped>
.navbar {
  margin-bottom: 20px;
}
.navbar-brand-logo {
  padding-bottom: 3px;
  margin-right: 15px;
  height: 22px;
}
</style>
